import { AnalyticsAttributesProvider, Markdown } from "../../components";
import { UiMarkdownModel } from "../../models";
import { getOrderedListCSS, getTextSizeCSS } from "../../styles";

import { StyledMarkdown } from "./UiMarkdown.styled";

export type UiMarkdownProps = {
    readonly model: UiMarkdownModel;
};

const UiMarkdown = ({ model }: UiMarkdownProps) => {
    const { content, entryTitle, orderedListAppearance, textSize } =
        model.content;

    // Apply styles at runtime via className
    const orderedListClass = orderedListAppearance
        ? getOrderedListCSS(orderedListAppearance)
        : "";
    const textSizeClass = textSize ? getTextSizeCSS(textSize) : "";

    return (
        <AnalyticsAttributesProvider
            value={{
                eventContainer: model.type,
                labelEnglish: entryTitle
            }}
        >
            <StyledMarkdown className={`${orderedListClass} ${textSizeClass}`}>
                <Markdown>{content}</Markdown>
            </StyledMarkdown>
        </AnalyticsAttributesProvider>
    );
};

export default UiMarkdown;
